import { Component, OnInit, TemplateRef } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { isComegoLockedForDate, isComegoLockedForDateFuture } from "@app/_helpers/timeLock";
import { COMEGO_ICON_MAP } from "@app/components/come-and-go-create-dialog/come-and-go-utils";
import {
	ComeAndGoMultiUpdateDialogComponent,
	WorkingHoursUpdateData,
} from "@app/components/come-and-go-multi-update-dialog/come-and-go-update-dialog.component";
import {
	ComeAndGoUpdateDialogComponent,
	ComeGoUpdateDialogData,
} from "@app/components/come-and-go-update-dialog/come-and-go-update-dialog.component";
import { DeletionUndoService } from "@app/services/deletion/deletion-undo.service";
import { UntilDestroy } from "@ngneat/until-destroy";
import { ComegoService, UserSettingsQuery } from "@timeghost/web-api";
import { map } from "rxjs";
import { TimerService, TimesListViewDay } from "../timer-calendar-view.service";

@UntilDestroy()
@Component({
	selector: "app-list-view",
	templateUrl: "./list-view.component.html",
	styleUrls: ["./list-view.component.scss"],
})
export class ListViewComponent implements OnInit {
	readonly iconMap = COMEGO_ICON_MAP;
	constructor(
		private comego: ComegoService,
		private userSettingsQuery: UserSettingsQuery,
		private dialog: MatDialog,
		private deletionService: DeletionUndoService,
		private timerService: TimerService
	) {}
	readonly isAMPM$ = this.userSettingsQuery.select().pipe(map((x) => !x.settings?.timeFormat24h));
	readonly viewDate$status = this.timerService.viewDate$status;
	readonly range = this.timerService.range;
	readonly maxRangeStart = this.timerService.maxRangeStart;
	readonly minRangeStart = this.timerService.minRangeStart;
	readonly scheduleEnabled$ = this.userSettingsQuery
		.select()
		.pipe(map((x) => !!x?.workspace?.schedules?.workspace?.enabled));
	readonly times$listView = this.timerService.times$listView$;

	ngOnInit(): void {}
	trackId(i: number, { id }: { id: string }) {
		return id;
	}
	editDay(view: TimesListViewDay) {
		return this.dialog
			.open(ComeAndGoMultiUpdateDialogComponent, {
				data: <WorkingHoursUpdateData>{
					time: {
						value: [],
						date: new Date(view.date),
						refetchFromDate: true,
					},
					forceRecreateDay: true,
				},
			})
			.afterClosed()
			.toPromise();
	}
	editItem(refItem: TimesListViewDay["comego"][0]) {
		return this.dialog.open(ComeAndGoUpdateDialogComponent, {
			data: {
				entity: refItem as any,
			} as ComeGoUpdateDialogData,
		});
	}

	async deleteItem(
		view: TimesListViewDay,
		refItem: TimesListViewDay["comego"][0],
		confirmDeleteTemplate?: TemplateRef<any>
	) {
		if (confirmDeleteTemplate) {
			const allowDelete = await this.dialog
				.open(confirmDeleteTemplate, {
					data: {
						entity: refItem,
					},
				})
				.afterClosed()
				.toPromise()
				.then((x) => x === true)
				.catch(() => false);
			if (!allowDelete) {
				return;
			}
		}
		await this.comego.delete(refItem as any);
	}

	async deleteDay(view: TimesListViewDay, confirmDeleteTemplate?: TemplateRef<any>) {
		if (confirmDeleteTemplate) {
			const allowDelete = await this.dialog
				.open(confirmDeleteTemplate, {
					data: {
						entity: view.comego[0],
					},
				})
				.afterClosed()
				.toPromise()
				.then((x) => x === true)
				.catch(() => false);
			if (!allowDelete) {
				return;
			}
		}
		await this.deletionService.deleteWithUndo({
			type: "comegoDay",
			view: { id: view.id, times: view.comego },
			day: view.date,
		});
	}

	isPendingDeletion(viewId: string): boolean {
		return this.deletionService.isPendingDeletion(viewId);
	}

	isItemEditable(refItem: TimesListViewDay["comego"][0]) {
		const userSettings = this.userSettingsQuery.getValue();
		let date = new Date();
		if (!refItem.type) date = new Date(refItem.id);
		else date = new Date(refItem.start);
		return !(isComegoLockedForDate(userSettings, date) || isComegoLockedForDateFuture(userSettings, date));
	}

	prev() {
		return this.timerService.prev();
	}
	today() {
		return this.timerService.today();
	}
	next() {
		return this.timerService.next();
	}
}
